module.exports = __webpack_public_path__ + "img/ico-language.006885a9.svg";